import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import NotFound from "~/components/NotFound/NotFound";
import { usePermissionRequirement } from "~/hooks/usePermission";
import { PermissionGuard } from "~/modules/Auth/PermissionGuard";
import { dashboardPermissionRequirements } from "~/modules/Dashboard/dashboardPermissionRequirements";
import { SalesCheckoutVariants } from "./SalesCheckoutVariants";
import SalesCRM from "./SalesCRM";

const SalesRouter = (): React.ReactElement => {
  // Do sekcji wchodzi też ktoś, kto ma tylko koszyki (administracja bez
  // `sales.read`) — pusty CRM bez zakładek nie jest dla niego stroną startową.
  const canReadSalesCrm = usePermissionRequirement(dashboardPermissionRequirements.salesCrm);

  return (
    <Routes>
      <Route index element={canReadSalesCrm ? <SalesCRM /> : <Navigate to="checkout-variants" replace />} />
      <Route
        path="checkout-variants"
        element={
          <PermissionGuard requirement={dashboardPermissionRequirements.salesCheckout}>
            <SalesCheckoutVariants />
          </PermissionGuard>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default SalesRouter;
